import type { NavigateFunction } from 'react-router-dom'
import type { ToastSeverity } from '@/shared/toast/ToastProvider'
import {
  SESSION_TIMEOUT_REDIRECT_MS,
  SURVEY_SESSION_TIMED_OUT,
  INSTRUMENT_UNAVAILABLE,
} from './instrument-info-messages'
import type { SurveySessionBlockedReason } from './survey-save-error'

type ShowToast = (message: string, severity?: ToastSeverity, autoHideDuration?: number) => void

function notifySurveyBlockedAndRedirect(
  showToast: ShowToast,
  navigate: NavigateFunction,
  message: string,
): void {
  showToast(message, 'error', SESSION_TIMEOUT_REDIRECT_MS)
  globalThis.setTimeout(() => {
    navigate('/', { replace: true })
  }, SESSION_TIMEOUT_REDIRECT_MS)
}

/** BFP-616 BR-7 — in-app toast then redirect to home when instrument is paused or stopped mid-survey. */
export function notifyInstrumentUnavailable(
  showToast: ShowToast,
  navigate: NavigateFunction,
  message: string = INSTRUMENT_UNAVAILABLE,
): void {
  notifySurveyBlockedAndRedirect(showToast, navigate, message)
}

/** TC-BE-11 / BR-BE-07 — toast (3s) then redirect to home; no full-page timeout screen. */
export function notifySurveySessionTimedOut(
  showToast: ShowToast,
  navigate: NavigateFunction,
  message: string = SURVEY_SESSION_TIMED_OUT,
): void {
  notifySurveyBlockedAndRedirect(showToast, navigate, message)
}

export function handleSurveySessionBlockedReason(
  reason: SurveySessionBlockedReason,
  handlers: {
    showToast: ShowToast
    navigate: NavigateFunction
    onTargetBlocked: () => void
  },
): void {
  if (reason === 'timeout') {
    notifySurveySessionTimedOut(handlers.showToast, handlers.navigate)
    return
  }
  handlers.onTargetBlocked()
}
